/* Lazy-load + autoplay voor promotievideo's op de homepage.
 *
 * De <video> staat in de HTML BEWUST zonder `src` en zonder `autoplay`.
 * Zodra `autoplay` op het element staat negeert Chrome de hint preload="none"
 * en downloadt hij de hele film meteen, ook als de sectie duizenden pixels
 * lager staat. Dit script zet de bron pas zodra de kaart in beeld komt en
 * pauzeert weer zodra hij eruit scrollt.
 *
 * Gebruik: <video data-hpv data-src="..." poster="..." muted loop playsinline
 *                 preload="none"></video>
 */
(function () {
  'use strict';

  var SEL = 'video[data-hpv]';
  var reduce = window.matchMedia &&
               window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function activate(v) {
    if (!v.src && v.dataset.src) {
      // Het attribuut alleen is voor Chrome niet altijd genoeg om te mogen spelen.
      v.muted = true;
      v.src = v.dataset.src;
      v.load();
    }
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  }

  function bind(v) {
    if (v.dataset.hpvBound) { return; }
    v.dataset.hpvBound = '1';

    // Bewegingsvoorkeur gerespecteerd: de poster blijft dan gewoon staan.
    if (reduce) { return; }

    if (!('IntersectionObserver' in window)) { activate(v); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          activate(e.target);
        } else if (e.target.src) {
          e.target.pause();
        }
      });
    }, { rootMargin: '300px 0px', threshold: 0.25 });

    io.observe(v);
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll(SEL), bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // De thema-editor hertekent secties zonder de pagina opnieuw te laden.
  document.addEventListener('shopify:section:load', scan);
})();
